import React, {useEffect} from 'react';

import Text from 'components/Text/Text';
import '../ConfirmRemoveBeerFromTap/ConfirmRemoveBeerFromTap.scss';
import {setRemovedBeerAC} from 'features/beersManager/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';

export const BeerRemoveSuccess = () => {
  const dispatch = useSetGlobalState();
  const {removedBeer} = useGlobalState((state) => state.beersManager);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setModalAC(null));
    }, 2000);
    return () => {
      clearTimeout(timer);
      dispatch(setRemovedBeerAC(null));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="remove-beer-from-tap">
      <Text className="remove-beer-from-tap__title" tag="h3">
        You successfully removed {removedBeer?.name.toUpperCase()} from the Beer list.
      </Text>
    </div>
  );
};
